import Simulator, { SimulatorProps } from '../simulator/simulator'

export default function CheckoutSimulatorExport(props: {simulatorInfo: SimulatorProps}) {
    return <Simulator {...props} />
}
